<template>
    <div v-if="client">
        <!-- winning stats thresholds -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Winning stats thresholds</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control"></p>
                </div>
            </div>
        </div>
        <div v-for="c in currencies" :key="c.id" class="field is-horizontal is-size-7">
            <div class="field-label is-normal">
                <label class="label is-size-7">{{c.id}}</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <currency-input
                            :value="client.settings.winningStatsSettings.winningStatsThresholds[c.id]"
                            :currency="c.id"
                            :set="(val) => client.settings.winningStatsSettings.winningStatsThresholds[c.id] = val"
                            class="input oc-input is-size-7"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';
import currencyService from '../../../../services/currency.service';

import CurrencyInput from '../../../common/currency-input.vue'

export default {
    name: 'client-settings-winning-stats',
    components: { CurrencyInput },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        await currencyService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/winning-stats.vue